import { render, staticRenderFns } from "./IndexCName.vue?vue&type=template&id=34f21ae0&scoped=true&"
import script from "./IndexCName.vue?vue&type=script&lang=js&"
export * from "./IndexCName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f21ae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34f21ae0')) {
      api.createRecord('34f21ae0', component.options)
    } else {
      api.reload('34f21ae0', component.options)
    }
    module.hot.accept("./IndexCName.vue?vue&type=template&id=34f21ae0&scoped=true&", function () {
      api.rerender('34f21ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/onePageAdv2/IndexCName.vue"
export default component.exports